import { FC, HTMLProps } from 'react';

import * as Styles from './country-flag.module.scss';
import classNames from 'classnames';

export const CountryFlag: FC<HTMLProps<HTMLImageElement>> = ({ className, ...props }) => {
    return <img className={classNames(Styles.countryFlag, className)} {...props} />;
};
